import { VIDIO_CHAT_SECURE, VIDIO_CHAT_HOST, VIDIO_CHAT_GKE_HOST, PNS_PUBLIC_WEB_API_HOST } from 'shared/env'

export const SEND_CHAT_MESSAGE_URL = buildChatURL('/v1/chat/send/message')
export const PNS_INBOX_URL = `${PNS_PUBLIC_WEB_API_HOST}/inbox`

function buildChatURL(endpoint) {
  const element = '.js-component[data-component="WebSocketConnection"]'
  const chatGKEHostEnabled = $(element).data('chat-gke-host-enabled')
  const vidioChatHost = chatGKEHostEnabled ? VIDIO_CHAT_GKE_HOST : VIDIO_CHAT_HOST

  const origin = `${VIDIO_CHAT_SECURE ? 'https' : 'http'}://${vidioChatHost}`
  return `${origin}${endpoint}`
}
